// extracted by mini-css-extract-plugin
export default {"innerTitleItem":"gstylesmenu_innerTitleItem__X8zc-","innerTitleText":"gstylesmenu_innerTitleText__Oy+c5","icon":"gstylesmenu_icon__9uYhy"};